import { BasketActionTypes } from "./types";
import { Basket } from "../../models/basket.model";
import { Dispatch } from "redux";
import { Property } from "../../models/property.model";
import { Product } from "../../models/product.model";
import _ from "lodash";

export interface BasketAction {
  type: BasketActionTypes;
  payload: Basket;
}

export const basketActions = {
  addToBasket: (basket: Basket, property: Property, product: Product) => {
    let propertyIndex = _.findIndex(basket.properties, {
      key: property.key
    });
    let isPropertyInbasket = propertyIndex > -1;

    if (!isPropertyInbasket) {
      property.products.push(product);
      basket.properties.push(property);
    } else {
      let isProductExisits =
        _.findIndex(basket.properties[propertyIndex].products, {
          productCode: product.productCode
        }) > -1;

      if (!isProductExisits) {
        property.products.push(product);
      }
    }
    return (dispatch: Dispatch) => {
      dispatch<BasketAction>({
        type: BasketActionTypes.ADD_TO_BASKET,
        payload: basket
      });
    };
  },
  removeFromBasket: (basket: Basket, property: Property, product: Product) => {
    let propertyIndex = _.findIndex(basket.properties, {
      key: property.key
    });

    let isPropertyInbasket = propertyIndex > -1;

    if (isPropertyInbasket) {
      let productIndex = _.findIndex(
        basket.properties[propertyIndex].products,
        { productCode: product.productCode }
      );

      if (productIndex > -1) {
        _.remove(basket.properties[propertyIndex].products, function(p) {
          return p.productCode === product.productCode;
        });
      }

      _.remove(basket.properties, function(p) {
        return p.products.length === 0;
      });
    }

   // console.log(basket);

    return (dispatch: Dispatch) => {
      dispatch<BasketAction>({
        type: BasketActionTypes.REMOVE_FROM_BASKET,
        payload: basket
      });
    };
  },
  updateBasket: (basket: Basket, property: Property) => {
    let propertyIndex = _.findIndex(basket.properties, {
      key: property.key
    });

    let isPropertyInbasket = propertyIndex > -1;

    if (isPropertyInbasket) {
      basket.properties[propertyIndex].tenancyCount = property.tenancyCount;
      basket.properties[propertyIndex].numberOfFlats = property.numberOfFlats;
    }

    return (dispatch: Dispatch) => {
      dispatch<BasketAction>({
        type: BasketActionTypes.UPDATE_BASKET,
        payload: basket
      });
    };
  },
  clearBasket: () => {
    return (dispatch: Dispatch) => {
      dispatch<BasketAction>({
        type: BasketActionTypes.CLEAR_BASKET,
        payload: new Basket()
      });
    }
  }
};
